import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { IntersectionModule } from '@epicuro-next/ataraxia/intersection';
import { VideoPlayerModule } from '@epicuro-next/ataraxia/video-player';
import { VimeoPlayerModule } from '@epicuro-next/ataraxia/vimeo-player';
import { YoutubePlayerModule } from '@epicuro-next/ataraxia/youtube-player';
import { DontTreeShake } from '@epicuro-next/elements/core';

import { MediaPreviewComponent } from './media-preview/media-preview.component';

@NgModule({
  imports: [
    CommonModule,
    ImageModule,
    YoutubePlayerModule,
    VideoPlayerModule,
    VimeoPlayerModule,
    IntersectionModule,
  ],
  declarations: [MediaPreviewComponent],
  exports: [MediaPreviewComponent],
})
export class MediaPreviewModule {}

DontTreeShake(MediaPreviewComponent);
